import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React from "react";
import PhoneInput from "react-phone-input-2";

const BusinessPhone = ({ inputValues, setInputValues }) => {
  const handleChange = (event) => {
    setInputValues((prevValues) => ({
      ...prevValues,
      contact: event,
    }));
  };

  const handleGenderChange = (e) => {
    setInputValues((prevValues) => ({
      ...prevValues,
      genderType: e.target.value,
    }));
  };

  return (
    <Box>
      <Grid container justifyContent={"center"}>
        <Grid item xs={12} sm={8} md={8}>
          <Typography
            variant="h3"
            sx={{ fontWeight: "700", fontSize: "25px", marginBottom: "15px" }}
          >
            How can clients get in touch?
          </Typography>
          <Typography
            variant="h3"
            sx={{ fontWeight: "700", fontSize: "18px", marginBottom: "5px" }}
          >
            Business phone number
          </Typography>
          <Typography
            variant="h3"
            sx={{ fontWeight: "400", fontSize: "15px", marginBottom: "15px" }}
          >
            The contact number is provided for clients to call if there is a
            problem or they need to cancel.
          </Typography>
          <PhoneInput
            country={"us"}
            inputClass="custom-phone-input"
            buttonClass="custom-phone-input-button"
            value={inputValues?.contact}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={8} md={8} sx={{ mt: 3 }}>
          <Typography
            variant="h3"
            sx={{ fontWeight: "700", fontSize: "18px", marginBottom: "5px" }}
          >
            Which gender do you provide services for?
          </Typography>
          <Typography
            variant="h3"
            sx={{ fontWeight: "400", fontSize: "15px", marginBottom: "15px" }}
          >
            Please select whether your branch provides services for males,
            females, or both.
          </Typography>
          <FormControl fullWidth>
            <InputLabel>Select Gender</InputLabel>
            <Select
              value={inputValues?.genderType || ""}
              onChange={(e) => handleGenderChange(e)}
            >
              <MenuItem value="male">Male</MenuItem>
              <MenuItem value="female">Female</MenuItem>
              <MenuItem value="both">Both</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  );
};

export default BusinessPhone;
